/**
 * MetricFilterBar — barra horizontal de filtros para os widgets do dashboard
 * (mapa, canais de origem, dispositivos).
 *
 * Lê as opções de `lib/metricFilters.js` para que adicionar uma nova métrica
 * seja uma única alteração de config. O botão ativo recebe a classe
 * `is-active`; clicar dispara `onChange(metricKey)`.
 */

import { memo } from 'react'
import Icon from './icons.jsx'
import { METRIC_FILTERS } from '../lib/metricFilters.js'

function MetricFilterBar({ active, onChange, disabled = false, items, ariaLabel }) {
  const list = items || METRIC_FILTERS
  return (
    <div
      className="metric-filter-bar"
      role="tablist"
      aria-label={ariaLabel || 'Filtrar widgets por métrica'}
    >
      {list.map((m) => {
        const isActive = active === m.key
        return (
          <button
            key={m.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            disabled={disabled}
            className={`metric-filter-btn ${isActive ? 'is-active' : ''}`}
            onClick={() => onChange?.(m.key)}
          >
            <Icon n={m.icon} s={13} />
            <span>{m.label}</span>
          </button>
        )
      })}
    </div>
  )
}

export default memo(MetricFilterBar)
